import { Component, Input } from '@angular/core';

function initialsFromName(name: string): string {
  if (!name || name === '—') return '?';
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (parts.length === 1) return parts[0].slice(0, 1).toUpperCase();
  return `${parts[0][0]}${parts[parts.length - 1][0]}`.toUpperCase();
}

/** Table cell with profile image + label (matches NEMT KPI tables). */
@Component({
  selector: 'app-br-entity-avatar-cell',
  templateUrl: './entity-avatar-cell.component.html'
})
export class BrEntityAvatarCellComponent {
  @Input() name: string;
  @Input() imageUrl: string;
  @Input() variant: 'driver' | 'cooperate' = 'driver';

  get label(): string {
    return this.name || '—';
  }

  get initials(): string {
    return initialsFromName(this.label);
  }
}
